import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import NumberInput from "./shared/NumberInput";

function getLeft(selectedObject: fabric.Object | null) {
  const boundingRect = selectedObject?.getBoundingRect(true);
  return boundingRect?.left || 0;
}

function Left() {
  const { canvas, selectedObject, coreHandler } = useContext(AppContext);
  const [left, setLeft] = useState(getLeft(selectedObject));

  // triggered by clicking layers
  useEffect(() => {
    const left = getLeft(selectedObject);
    setLeft(left);
  }, [selectedObject]);

  // triggered by fabric controls
  useEffect(() => {
    function onModified(event: any) {
      const left = getLeft(selectedObject);
      setLeft(left);
    }

    coreHandler?.eventHandler.on("object:modified", onModified);
    return () => {
      coreHandler?.eventHandler.off("object:modified", onModified);
    };
  }, [coreHandler, selectedObject]);

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (selectedObject) {
      const value = parseInt(event.target.value, 10);
      selectedObject.set("left", value);

      canvas?.renderAll();
      setLeft(value);
    }
  }

  return (
    <NumberInput
      onChange={onChange}
      value={left}
    />
  );
}

export default Left;
